export default __webpack_public_path__ + "static/media/snowmeltrunoff.f1849b45.png";